import React, { useContext, useEffect, useState } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import Head from 'next/head'
import ConditionalRender, {
  Original,
  Experiment
} from '@/components/ConditionalRender'
import { Image } from 'pcln-design-system'
import { AppDownloadBannerContentType } from './types'
import useAppBanner from './useAppBanner'
import AppBanner from './AppBanner'

const AppBannerWrapper = ({
  content,
  ...props
}: {
  content: AppDownloadBannerContentType
} & Record<string, unknown>) => {
  const showAppBanner = useAppBanner()
  const {
    referral,
    webstats: { clientGUID }
  } = useContext(BootstrapDataContext)
  const RenderAppBanner = () => {
    return showAppBanner ? (
      <AppBanner
        {...{
          referral: referral ?? {},
          clientGUID: clientGUID ?? '',
          ...content,
          ...props
        }}
      />
    ) : null
  }

  const [userAgent, setUserAgent] = useState('')

  useEffect(() => {
    const { userAgent: UA } = navigator
    setUserAgent(UA)
  }, [])

  const isIphone = userAgent.match(/iPhone/i)
  const webkit = !!userAgent.match(/WebKit/i)
  const iOSSafari = isIphone && webkit && !userAgent.match(/CriOS/i)

  const impressionUrl = [
    'https://imp.control.kochava.com/track/impression?campaign_id=koiospriceline388053593d51c5580c1da575ac62c7&network_id=1017',
    `&PAGEID=IOS_SMARTBANNER`,
    `&REFID=${referral?.sourceId ?? ''}${referral?.id ?? ''}`,
    `&REFCLICKID=${referral?.clickId ?? ''}`,
    `&SUB_SITE_ID=${clientGUID}&site_id=1`
  ].join('')

  return iOSSafari ? (
    <ConditionalRender experimentCode="MBL_IOS_SMART_BANNER">
      <Original>
        <RenderAppBanner />
      </Original>
      <Experiment>
        <Head>
          <meta
            name="apple-itunes-app"
            content="app-id=336381998"
            key="apple-smart-banner"
          />
        </Head>
        <Image src={impressionUrl} height="0" width="1" border="0" />
      </Experiment>
    </ConditionalRender>
  ) : (
    <RenderAppBanner />
  )
}

export default AppBannerWrapper
